import { prefix, ajax } from './common';

export async function getCarouselAds(account_type = '') {
  return await ajax({
    url: prefix + '/promotions',
    data: {
      account_type
    }
  });
}